/* "See Reviews from Similar Dogs" (Review Intelligence V1.2.2: unified ABUBA review pool, simplified filters, business weight ranges, kg+lb / cm+in display).
   Structured Size Case data is FILTER METADATA ONLY. It finds original Alpha reviews; the review text, star rating and date are fetched from Alpha and shown unchanged.
   Display policy (V1.2.1, unchanged): reviewer name (including masked) and customer photos/media are NEVER read, kept or rendered. If any review in the rendered set cannot be fetched,
   the component fails closed: no review cards, no count, no translation notice, no disclosure, no Show more, only the unavailable message.
   One pool: the same 51 distinct reviews are available on LITE2 and ABUBA4. The page only limits which Size Used options are SELECTABLE (data-sizes); it never removes reviews from the pool.
   Filters (optional, combine with AND, never relaxed automatically): Dog Weight, Size Used, Back Length (under "More filters"). Chest Girth is not a filter; it is shown on the card when present.
   Range matching uses min/max only: a case matches a band when [min, max] overlaps [band start, band end); a boundary value belongs to the UPPER band; a case with no value for a filtered field does not match.
   Counts are DISTINCT reviews (a review that describes two dogs is one review). Option count = reviews matching every OTHER selected filter AND that option.
   Units are display-only (stored values are metric). */
(function (root) {
  var INF = Infinity;

  /* ===== configuration (edit here only) ===== */
  var SHOW_MODEL = false;               /* V1.2.2: no customer-facing model line. alpha_product_id stays in the data as internal provenance. */
  var HIDE_EMPTY_POOL_BUCKETS = false;  /* true would hide buckets that are empty for the WHOLE pool (never filter-dependent zeros) */
  var KG_TO_LB = 2.20462262;
  var CM_TO_IN = 1 / 2.54;
  /* Approved business ranges, half-open [min, max). max null = no upper limit (a review of any weight lands in the top bucket). */
  var WEIGHT_BUCKETS = [
    { min: 0, max: 5 }, { min: 5, max: 8 }, { min: 8, max: 12 }, { min: 12, max: 16 },
    { min: 16, max: 20 }, { min: 20, max: 30 }, { min: 30, max: null }
  ];
  var BACK_BUCKETS = [{ min: 0, max: 46 }, { min: 46, max: null }];
  var MODEL_NAMES = { '8204520259889': 'LITE2', '9078998597937': 'ABUBA3' }; /* only used when SHOW_MODEL is true */

  function lb0(kgv) { return Math.round(kgv * KG_TO_LB); }
  function in1(cm) { return (Math.round(cm * CM_TO_IN * 10) / 10).toFixed(1); }
  function weightLabel(b) {
    if (b.min === 0) return 'Under ' + b.max + ' kg / ' + lb0(b.max) + ' lb';
    if (b.max === null) return b.min + ' kg+ / ' + lb0(b.min) + ' lb+';
    return b.min + '–' + b.max + ' kg / ' + lb0(b.min) + '–' + lb0(b.max) + ' lb';
  }
  /* back bands are [min, max) in whole cm; the label names the largest whole centimetre inside the band */
  function backLabel(b) {
    if (b.min === 0) return 'Up to ' + (b.max - 1) + ' cm / ' + in1(b.max - 1) + ' in';
    if (b.max === null) return b.min + ' cm+ / ' + in1(b.min) + ' in+';
    return b.min + '–' + (b.max - 1) + ' cm / ' + in1(b.min) + '–' + in1(b.max - 1) + ' in';
  }
  function toBands(buckets) { return buckets.map(function (b) { return [b.min, b.max === null ? INF : b.max]; }); }

  var FILTERS = {
    weight: { label: 'Dog Weight', min: 'weight_min_kg', max: 'weight_max_kg', buckets: WEIGHT_BUCKETS, bands: toBands(WEIGHT_BUCKETS), text: weightLabel },
    back: { label: 'Back Length', min: 'back_length_min_cm', max: 'back_length_max_cm', buckets: BACK_BUCKETS, bands: toBands(BACK_BUCKETS), text: backLabel }
  };
  var ORDER = ['weight', 'size', 'back'];

  function num(v) { return typeof v === 'number' && isFinite(v); }

  function matchesOption(c, key, value) {
    if (key === 'size') return c.size_used === value;
    var f = FILTERS[key], band = f.bands[value];
    if (!band || !num(c[f.min]) || !num(c[f.max])) return false;
    return c[f.min] < band[1] && c[f.max] >= band[0];
  }

  /* rows (Size Case metadata) that pass every selected filter except skipKey */
  function filterRows(rows, sel, skipKey) {
    return rows.filter(function (c) {
      for (var i = 0; i < ORDER.length; i++) {
        var k = ORDER[i];
        if (k === skipKey) continue;
        var v = sel[k];
        if (v === null || v === undefined || v === '') continue;
        if (!matchesOption(c, k, v)) return false;
      }
      return true;
    });
  }

  /* distinct Alpha reviews from matching rows: [{ id, pid, rows: [matching rows] }], ordered by Alpha id */
  function reviewsOf(rows) {
    var map = {}, list = [];
    rows.forEach(function (c) {
      var id = String(c.alpha_review_id);
      if (!map[id]) { map[id] = { id: id, pid: String(c.alpha_product_id), rows: [] }; list.push(map[id]); }
      map[id].rows.push(c);
    });
    return list.sort(function (a, b) { return parseInt(a.id, 10) - parseInt(b.id, 10); });
  }

  function optionCount(rows, sel, key, value) {
    return reviewsOf(filterRows(rows, sel, key).filter(function (c) { return matchesOption(c, key, value); })).length;
  }

  /* ----- display text (kg + lb, cm + in; display-only conversion) ----- */
  function kg(v) { return (Math.round(v * 100) / 100).toString(); }
  function fmt1(v) { return (Math.round(v * 10) / 10).toFixed(1); }

  function weightText(c) {
    if (!num(c.weight_min_kg)) return '';
    if (c.weight_kind === 'range' && c.weight_min_kg !== c.weight_max_kg) {
      return kg(c.weight_min_kg) + '–' + kg(c.weight_max_kg) + ' kg / ' + fmt1(c.weight_min_kg * KG_TO_LB) + '–' + fmt1(c.weight_max_kg * KG_TO_LB) + ' lb';
    }
    var v = num(c.dog_weight_kg) ? c.dog_weight_kg : c.weight_min_kg;
    return (c.weight_kind === 'approx' ? 'About ' : '') + kg(v) + ' kg / ' + fmt1(v * KG_TO_LB) + ' lb';
  }

  function lengthText(lo, hi) {
    if (!num(lo)) return '';
    if (!num(hi) || hi === lo) return kg(lo) + ' cm / ' + fmt1(lo * CM_TO_IN) + ' in';
    return kg(lo) + '–' + kg(hi) + ' cm / ' + fmt1(lo * CM_TO_IN) + '–' + fmt1(hi * CM_TO_IN) + ' in';
  }

  /* known structured fields only, fixed order: weight, back length, size used, chest girth (muted), model (muted, off by default).
     Each part: [label, value, muted] */
  function metaParts(c) {
    var p = [];
    var w = weightText(c); if (w) p.push(['Dog weight', w, false]);
    var b = lengthText(c.back_length_min_cm, c.back_length_max_cm); if (b) p.push(['Back length', b, false]);
    if (c.size_used) p.push(['Size used', c.size_used, false]);
    var ch = lengthText(c.chest_girth_min_cm, c.chest_girth_max_cm); if (ch) p.push(['Chest girth', ch, true]);
    if (SHOW_MODEL && MODEL_NAMES[String(c.alpha_product_id)]) p.push(['Model', MODEL_NAMES[String(c.alpha_product_id)], true]);
    return p;
  }

  function countText(n, filtered) {
    if (filtered) return n === 1 ? '1 review matches' : n + ' reviews match';
    return n === 1 ? '1 real customer review' : n + ' real customer reviews';
  }

  var api = { FILTERS: FILTERS, ORDER: ORDER, WEIGHT_BUCKETS: WEIGHT_BUCKETS, BACK_BUCKETS: BACK_BUCKETS, matchesOption: matchesOption, filterRows: filterRows,
    reviewsOf: reviewsOf, optionCount: optionCount, weightText: weightText, lengthText: lengthText, metaParts: metaParts, countText: countText,
    weightLabel: weightLabel, backLabel: backLabel };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.AbubaReviewFinder = api;

  /* ---------- UI ---------- */
  var el = document.querySelector('[data-abuba-similar="ready"]');
  if (!el) return;
  var dataEl = document.getElementById('abuba-size-cases');
  var rows = [];
  try { rows = JSON.parse(dataEl.textContent); } catch (e) { rows = []; }
  if (!rows.length) { el.hidden = true; return; }

  var shopId = el.getAttribute('data-shop-id') || '';
  var sizes = (el.getAttribute('data-sizes') || '').split(',').filter(Boolean); /* selectable Size Used options only; the review pool is not filtered by this */
  var selects = {};
  ORDER.forEach(function (k) { selects[k] = el.querySelector('[data-abuba-filter="' + k + '"]'); });
  var moreToggle = el.querySelector('[data-abuba-more-toggle]');
  var moreBox = el.querySelector('[data-abuba-more-filters]');
  var chipsEl = el.querySelector('[data-abuba-sim-chips]');
  var countEl = el.querySelector('[data-abuba-sim-count]');
  var resetAll = el.querySelector('[data-abuba-sim-reset]');
  var list = el.querySelector('[data-abuba-sim-list]');
  var more = el.querySelector('[data-abuba-sim-more]');
  var empty = el.querySelector('[data-abuba-sim-empty]');
  var unavailable = el.querySelector('[data-abuba-sim-unavailable]');
  var translation = el.querySelector('[data-abuba-sim-translation]');
  var disclosure = el.querySelector('[data-abuba-sim-disclosure]');
  var note = el.querySelector('[data-abuba-sim-note]');
  var sel = { weight: null, size: null, back: null };
  var INITIAL = 3, STEP = 6, shown = INITIAL, renderToken = 0, moreOpen = false;
  var cache = {}; /* review id -> Promise of parsed review (one request per review, only when it is about to be shown) */

  function labelFor(k) { return k === 'size' ? 'Size Used' : FILTERS[k].label; }
  function valueLabel(k, v) { return k === 'size' ? v : FILTERS[k].text(FILTERS[k].buckets[v]); }
  function anyFilter() { return ORDER.some(function (k) { return sel[k] !== null; }); }
  function poolHas(k, i) { return reviewsOf(rows.filter(function (c) { return matchesOption(c, k, i); })).length > 0; }

  function buildOptions() {
    ORDER.forEach(function (k) {
      var s = selects[k];
      if (!s) return;
      var values = k === 'size' ? sizes : FILTERS[k].buckets.map(function (b, i) { return i; });
      s.textContent = '';
      var any = document.createElement('option'); any.value = ''; any.textContent = 'Any'; s.appendChild(any);
      values.forEach(function (v) {
        var isSel = sel[k] !== null && String(sel[k]) === String(v);
        if (HIDE_EMPTY_POOL_BUCKETS && k !== 'size' && !isSel && !poolHas(k, v)) return;
        var n = optionCount(rows, sel, k, v);
        var o = document.createElement('option');
        o.value = String(v);
        o.textContent = valueLabel(k, v) + ' (' + n + ')';
        if (n === 0 && !isSel) o.disabled = true; /* keep the full label and (0); never hide, never disable the selected option */
        if (isSel) o.selected = true;
        s.appendChild(o);
      });
      if (sel[k] === null) s.value = '';
    });
  }

  function syncMore() {
    if (!moreToggle || !moreBox) return;
    var open = moreOpen || sel.back !== null; /* auto-expand while Back Length is selected */
    moreBox.hidden = !open;
    moreToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    moreToggle.textContent = open ? 'More filters −' : 'More filters +';
  }

  function renderChips() {
    chipsEl.textContent = '';
    ORDER.forEach(function (k) {
      if (sel[k] === null) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'abuba-sim__chip'; b.setAttribute('data-abuba-chip', k);
      b.setAttribute('aria-label', 'Clear ' + labelFor(k) + ' filter: ' + valueLabel(k, sel[k]));
      b.textContent = labelFor(k) + ': ' + valueLabel(k, sel[k]) + ' ×';
      chipsEl.appendChild(b);
    });
    chipsEl.hidden = !anyFilter();
  }

  /* ----- Alpha: fetch ONE original review (Alpha's own per-review fragment) and keep only text, star rating and date ----- */
  function alphaUrl(r) {
    return '/apps/alpha-review/widget/render?type=alpha_detail_review&item_per_page=8&skip=0&limit=8&review_id=' +
      encodeURIComponent(r.id) + '&product_platform_id=' + encodeURIComponent(r.pid) + '&shop_platform_id=' + encodeURIComponent(shopId);
  }

  function parseFragment(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var content = doc.querySelector('.alpha-detail-info-container .ar-review-content');
    var ratingBox = doc.querySelector('.alpha-detail-info-container .ar-text-rating');
    if (!content || !ratingBox) throw new Error('unexpected fragment');
    var stars = [].slice.call(ratingBox.querySelectorAll('svg')).filter(function (s) { return s.getAttribute('fill'); });
    var date = null;
    var etc = content.nextElementSibling;
    if (etc && etc.classList.contains('ar-etc-text')) date = etc.textContent.trim();
    return { text: content.textContent, stars: stars.length, date: date };
  }

  function loadReview(r) {
    if (!cache[r.id]) {
      cache[r.id] = new Promise(function (resolve, reject) {
        var ctl = typeof AbortController === 'function' ? new AbortController() : null;
        var t = setTimeout(function () { if (ctl) ctl.abort(); reject(new Error('timeout')); }, 12000);
        fetch(alphaUrl(r), { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
          .then(function (res) { if (!res.ok) throw new Error('http ' + res.status); return res.text(); })
          .then(function (html) { clearTimeout(t); resolve(parseFragment(html)); })
          .catch(function (e) { clearTimeout(t); reject(e); });
      });
      cache[r.id].catch(function () { delete cache[r.id]; }); /* allow a retry later */
    }
    return cache[r.id];
  }

  function starSvg(on) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', '0 0 11 10.5'); s.setAttribute('width', '15'); s.setAttribute('height', '14'); s.setAttribute('aria-hidden', 'true');
    s.setAttribute('fill', on ? '#7c2124' : '#d9d2c8');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'M5.5 8.439 8.9 10.5 8 6.615 11 4l-3.955-.337L5.5 0 3.954 3.664 0 4l3 2.615-.9 3.885z');
    s.appendChild(p);
    return s;
  }

  function reviewCard(r, data) {
    var li = document.createElement('li');
    li.className = 'abuba-rv';
    li.setAttribute('data-review-id', r.id);
    /* structured line(s): known fields of the matching Size Case(s) only */
    r.rows.forEach(function (c) {
      var parts = metaParts(c);
      if (!parts.length) return;
      var m = document.createElement('p'); m.className = 'abuba-rv__meta';
      parts.forEach(function (pr) {
        var s = document.createElement('span');
        if (pr[2]) s.className = 'abuba-rv__muted';
        var b = document.createElement('b'); b.textContent = pr[0] + ' ';
        s.appendChild(b); s.appendChild(document.createTextNode(pr[1]));
        m.appendChild(s);
      });
      li.appendChild(m);
    });
    var head = document.createElement('div'); head.className = 'abuba-rv__head';
    var st = document.createElement('span'); st.className = 'abuba-rv__stars';
    st.setAttribute('role', 'img'); st.setAttribute('aria-label', data.stars + ' out of 5 stars');
    for (var i = 0; i < 5; i++) st.appendChild(starSvg(i < data.stars));
    head.appendChild(st);
    if (data.date) { var d = document.createElement('span'); d.className = 'abuba-rv__date'; d.textContent = data.date; head.appendChild(d); }
    li.appendChild(head);
    var t = document.createElement('p'); t.className = 'abuba-rv__text'; t.textContent = data.text; li.appendChild(t);
    return li;
  }

  function placeholderCard(r) {
    var li = document.createElement('li');
    li.className = 'abuba-rv abuba-rv--loading'; li.setAttribute('data-review-id', r.id);
    li.setAttribute('aria-busy', 'true');
    var s = document.createElement('span'); s.className = 'abuba-rv__skel'; s.textContent = 'Loading review…'; li.appendChild(s);
    return li;
  }

  /* notices (disclosure, translation, "not a size recommendation" note) show only when reviews are not in the failure state */
  function showNotices(on, withTranslation) {
    if (disclosure) disclosure.hidden = !on;
    if (note) note.hidden = !on;
    if (translation) translation.hidden = !(on && withTranslation);
  }

  function render() {
    buildOptions();
    syncMore();
    renderChips();
    var token = ++renderToken;
    var reviews = reviewsOf(filterRows(rows, sel));
    countEl.textContent = countText(reviews.length, anyFilter());
    countEl.hidden = false;
    resetAll.hidden = !anyFilter();
    list.textContent = '';
    unavailable.hidden = true;
    showNotices(false, false);
    if (!reviews.length) { empty.hidden = false; list.hidden = true; more.hidden = true; showNotices(true, false); return; }
    empty.hidden = true; list.hidden = false;
    var visible = reviews.slice(0, shown);
    more.hidden = reviews.length <= shown;
    visible.forEach(function (r) { list.appendChild(placeholderCard(r)); });
    /* fail closed: cards are shown only when EVERY review in the rendered set was fetched; otherwise only the unavailable message */
    Promise.all(visible.map(loadReview)).then(function (datas) {
      if (token !== renderToken) return;
      list.textContent = '';
      visible.forEach(function (r, i) { list.appendChild(reviewCard(r, datas[i])); });
      showNotices(true, true);
    }, function () {
      if (token !== renderToken) return;
      list.textContent = ''; list.hidden = true; more.hidden = true;
      showNotices(false, false);
      countEl.hidden = true; /* failure state shows only the unavailable message */
      unavailable.hidden = false;
    });
  }

  function onChange(k) {
    return function () {
      var v = selects[k].value;
      sel[k] = v === '' ? null : (k === 'size' ? v : parseInt(v, 10));
      shown = INITIAL; render();
    };
  }
  ORDER.forEach(function (k) { if (selects[k]) selects[k].addEventListener('change', onChange(k)); });
  if (moreToggle) moreToggle.addEventListener('click', function () {
    if (sel.back !== null) return; /* stays open while Back Length is selected */
    moreOpen = !moreOpen; syncMore();
  });
  chipsEl.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-abuba-chip]');
    if (!b) return;
    var k = b.getAttribute('data-abuba-chip'); sel[k] = null; shown = INITIAL; render();
    if (selects[k]) selects[k].focus();
  });
  resetAll.addEventListener('click', function () { sel = { weight: null, size: null, back: null }; shown = INITIAL; render(); });
  more.addEventListener('click', function () { shown += STEP; render(); });
  render();
})(typeof window !== 'undefined' ? window : this);
